var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFree())?_c('span',{staticClass:"badge badge-success"},[_vm._v("Free")]):(_vm.isPaid())?_c('span',{staticClass:"badge badge-danger"},[_vm._v("Paid")]):(_vm.isTrial())?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Trial "+_vm._s(_vm.duration)+" days")]):(_vm.isRental())?_c('span',{staticClass:"badge badge-info"},[_vm._v("Rental "+_vm._s(_vm.duration)+" days")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd5ef3de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SaleOption.vue
// module id = 325
// module chunks = 1